/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UserSort,
    UserSortFromJSON,
    UserSortFromJSONTyped,
    UserSortToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchUserRequest
 */
export interface SearchUserRequest {
    /**
     * 
     * @type {number}
     * @memberof SearchUserRequest
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchUserRequest
     */
    pageSize?: number;
    /**
     * 
     * @type {UserSort}
     * @memberof SearchUserRequest
     */
    sortMode?: UserSort;
    /**
     * 
     * @type {string}
     * @memberof SearchUserRequest
     */
    searchQuery?: string | null;
}

export function SearchUserRequestFromJSON(json: any): SearchUserRequest {
    return SearchUserRequestFromJSONTyped(json, false);
}

export function SearchUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchUserRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'sortMode': !exists(json, 'sortMode') ? undefined : UserSortFromJSON(json['sortMode']),
        'searchQuery': !exists(json, 'searchQuery') ? undefined : json['searchQuery'],
    };
}

export function SearchUserRequestToJSON(value?: SearchUserRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'sortMode': UserSortToJSON(value.sortMode),
        'searchQuery': value.searchQuery,
    };
}


